import React, { useRef, useState } from "react";
import AgentActivityPage from "./AgentActivityPage";

import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import { useDispatch, useSelector } from "react-redux";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { setActiveSectionKey } from "../../../redux/actions/section/section";
import TicketsSummaryCard from "./TicketsSummaryCard";
import { getPaneIndex } from "../../../redux/constants";

const AgentActivitySectionInsights = ({ dashboardData }) => {
  const divRef = useRef();
  const dispatch = useDispatch();
  const activeSectionKey = useSelector(
    (state) => state.Section.activeSectionKey
  );
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const panes = useSelector((state) => state.Tab1.panes);
  let index = getPaneIndex(panes, activeKey);
  const sections = panes?.[index]?.sections;
  const preWidgetLoader = useSelector((state) => state.apiCall.preWidgetLoader);
  const setdivHeightRange = () => {
    const sectionData = sections?.map((el, i) => {
      if (el.section_id === divRef?.current?.id) {
        el.divHeight = divRef?.current?.clientHeight;
      }
      return el;
    });
    let divHeight = sectionData?.map((el) => {
      return el.divHeight;
    });

    let arr = [];
    divHeight?.map((el, i) => {
      if (i == 0) {
        arr.push({ start: 0, end: el });
      } else {
        let value = { start: arr[i - 1].end, end: arr[i - 1].end + el };
        arr.push(value);
      }
    });
    return arr;
  };

  const setActivekey = (top, arr) => {
    arr?.map((el, i) => {
      if (top >= el?.start && top < el?.end) {
        dispatch(setActiveSectionKey(sections[i].section_id));
      }
    });
  };

  useScrollPosition(
    ({ currPos }) => {
      const arr = setdivHeightRange();

      setActivekey(window.pageYOffset, arr);
    },
    [sections, activeSectionKey],
    divRef,
    false,
    1000
  );

  return (
    <div
      className="pb-15"
      ref={divRef}
      name={dashboardData?.section_id}
      id={dashboardData?.section_id}
      key={dashboardData?.section_id}
    >
      <div
        className="portlet1 p-10 border-radius-4 line-height-normal mb-15"
        style={{
          backgroundColor:
            authParams?.theme_type === "1"
              ? "rgb(59 81 117 / 50%)"
              : "rgba(255, 255, 255, 0.3)",
        }}
      >
        <div className="line-height-normal">
          <span className="text_heading-Slab font-size16">
            {dashboardData?.section_name}
          </span>
          {dashboardData?.section_description ? (
            <div className="text_regular-gray font-weight400">
              {dashboardData?.section_description}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {dashboardData?.widgets?.length > 0 ? (
        <>
          {dashboardData?.widgets?.map((el, i) => {
            return <AgentActivityPage widgetsData={el} />;
          })}
          <div className="row mr-0 mt-15 mb-15">
            {dashboardData && (
              <TicketsSummaryCard
                TicketSummarywidget={dashboardData?.widgets}
              />
            )}
          </div>
        </>
      ) : (
        <div
          className="bg__white d-flex align-items-center justify-content-center mb-15 text-center pt-4 mt-15"
          style={{ minHeight: "calc(100vh - 26.4rem)" }}
        >
          {" "}
          <div className="loader">
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgentActivitySectionInsights;
